import { render, staticRenderFns } from "./SplashScreenMapPlants.vue?vue&type=template&id=29b3f8d3&scoped=true&lang=pug&"
var script = {}
import style0 from "./SplashScreenMapPlants.vue?vue&type=style&index=0&id=29b3f8d3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b3f8d3",
  null
  
)

export default component.exports